module.exports = __webpack_public_path__ + "components/discount-pages/roadsurfer/static/roadsurfer-1200@2x-dcd71c3092ea4e953f70fef2f47a382c.jpg";